import type { Messages } from '../messages'

export const hi: Messages = {
  meta: {
    title: 'विभा शर्मा — पोर्टफोलियो',
    description:
      'डेटा वैज्ञानिक — पावर BI, SQL, पायथन, सार्वजनिक और निजी क्षेत्र में विश्लेषण।',
  },
  nav: {
    about: 'परिचय',
    projects: 'परियोजनाएँ',
    experience: 'अनुभव',
    contact: 'संपर्क',
    skipToContent: 'सामग्री पर जाएँ',
  },
  hero: {
    role: 'डेटा वैज्ञानिक',
    location: 'ओटावा, ओंटारियो, कनाडा',
    tagline:
      'डेटा को निर्णयों में बदलना — पावर BI, SQL व NoSQL, पायथन, आँकड़े और डेटा तैयारी; वित्त, स्वास्थ्य, कृषि और सार्वजनिक क्षेत्र में।',
    ctaPrimary: 'अनुभव देखें',
    ctaSecondary: 'संपर्क करें',
  },
  about: {
    title: 'परिचय',
    portraitAlt: 'विभा शर्मा का पेशेवर चित्र',
    lead:
      'माइक्रोसॉफ्ट पावर BI, SAP BusinessObjects और माइक्रोसॉफ्ट BI स्टैक के साथ पाँच वर्षों के व्यावहारिक अनुभव में, मैं कच्चे डेटा को विभिन्न उद्योगों में उपयोगी अंतर्दृष्टि में बदलती हूँ।',
    p1:
      'मैंने वित्त, स्वास्थ्य सेवा और कृषि में काम किया है और एक डेटा वैज्ञानिक के रूप में डोमेन-विशिष्ट चुनौतियों को समझती हूँ। संबंधपरक और बहुआयामी डेटाबेस, सिस्टम व डेटा एकीकरण, रिपोर्टिंग, विश्लेषण और मजबूत डेटा प्रबंधन मेरे मुख्य क्षेत्र हैं।',
    p2:
      'ट्रांसपोर्ट कनाडा, कृषि व कृषि-खाद्य कनाडा और विप्रो लिमिटेड में भूमिकाओं ने सार्वजनिक व निजी संगठनों में डेटा-आधारित निर्णय के प्रति मेरे समर्पण को मजबूत किया है।',
    clearance:
      '2030 तक वैध कनाडाई विश्वसनीयता (Reliability) मंजूरी — सुरक्षा और गोपनीयता के प्रति प्रतिबद्धता।',
    stats: {
      years: '6+ वर्ष का अनुभव',
      domains: 'वित्त · स्वास्थ्य · कृषि · सार्वजनिक क्षेत्र',
      clearanceLabel: 'विश्वसनीयता मंजूरी',
    },
  },
  projects: {
    title: 'परियोजनाएँ और मुख्य बिंदु',
    subtitle:
      'मेरी भूमिकाओं से प्रतिनिधि कार्य — डैशबोर्ड, एकीकरण और विश्लेषण वितरण।',
    items: {
      aafc: {
        title: 'कृषि व सार्वजनिक विश्लेषण',
        period: '2023 — वर्तमान',
        summary:
          'कृषि व कृषि-खाद्य कनाडा के लिए डेटा विज्ञान और बिज़नेस इंटेलिजेंस — एक बड़ी सरकारी एजेंसी में अनुसंधान-संरेखित विश्लेषण, रिपोर्टिंग और डेटा समाधान।',
        tags: 'पावर BI · डेटा एकीकरण · सार्वजनिक क्षेत्र',
      },
      transport: {
        title: 'ट्रांसपोर्ट कनाडा — पावर BI वितरण',
        period: '2020 — 2022',
        summary:
          'पावर BI और पावर पिवट में जटिल DAX, मॉडल किए गए डेटासेट, पावर BI सर्विस और रिपोर्ट सर्वर पर प्रकाशित रिपोर्ट, शेयरपॉइंट एकीकरण, और पावरशेल व शेड्यूलर के साथ स्वचालित रिफ्रेश।',
        tags: 'DAX · पावर क्वेरी · शेयरपॉइंट · स्वचालन',
      },
      wipro: {
        title: 'विप्रो — क्रॉस-इंडस्ट्री BI',
        period: '2015 — 2018',
        summary:
          'भू-स्थानिक और स्वास्थ्य सहित विविध डेटा पर पावर BI और वेबी रिपोर्ट, ग्राहक PoC, SAP BusinessObjects यूनिवर्स और BI पाइपलाइन के लिए डेटा प्रोफाइलिंग।',
        tags: 'SAP BO · स्वास्थ्य · भू-स्थानिक · वेबी',
      },
    },
  },
  experience: {
    title: 'अनुभव',
    workHistory: 'कार्य अनुभव',
    education: 'शिक्षा',
    certifications: 'प्रमाणपत्र',
    jobs: {
      aafc_ds: {
        title: 'डेटा वैज्ञानिक (स्थायी)',
        org: 'कृषि व कृषि-खाद्य कनाडा',
        period: 'अप्रैल 2024 — वर्तमान',
        location: 'ओटावा, कनाडा',
        bullets: [
          'सरकारी अनुसंधान और नीति संदर्भ में डेटा विज्ञान और विश्लेषण।',
          'माइक्रोसॉफ्ट BI पारिस्थितिकी तंत्र और संबंधित डेटा प्लेटफॉर्म पर निरंतर वितरण।',
        ],
      },
      aafc_bi: {
        title: 'डेटा वैज्ञानिक — बिज़नेस इंटेलिजेंस विशेषज्ञ',
        org: 'कृषि व कृषि-खाद्य कनाडा',
        period: 'जुलाई 2023 — अप्रैल 2024',
        location: 'ओटावा, कनाडा',
        bullets: ['अनुसंधान शाखा के भीतर विशेषज्ञ-स्तरीय BI और विश्लेषण।'],
      },
      tc: {
        title: 'प्रोग्रामर विश्लेषक',
        org: 'ट्रांसपोर्ट कनाडा',
        period: 'जून 2020 — मार्च 2022',
        location: 'ओटावा, कनाडा',
        bullets: [
          'पावर BI और पावर पिवट के लिए उन्नत DAX; कम्प्यूटेड टेबल और समृद्ध विज़ुअल।',
          'पावर BI सर्विस और रिपोर्ट सर्वर पर प्रकाशन; शेयरपॉइंट ऑनलाइन एक्सेस।',
          'पावरशेल और विंडोज टास्क शेड्यूलर के माध्यम से पावर क्वेरी रिफ्रेश स्वचालित।',
        ],
      },
      wipro: {
        title: 'डेटा वैज्ञानिक',
        org: 'विप्रो लिमिटेड',
        period: 'दिसंबर 2015 — अगस्त 2018',
        location: 'गुड़गांव, भारत',
        bullets: [
          'भू-स्थानिक और स्वास्थ्य सहित विविध डेटा पर पावर BI और वेबी।',
          'ग्राहक PoC, डेटा वेयरहाउस से SAP BO यूनिवर्स, और BI के लिए डेटा प्रोफाइलिंग।',
        ],
      },
    },
    edu: {
      masters: {
        degree: 'मास्टर डिग्री, सूचना प्रौद्योगिकी',
        school: 'ओटावा विश्वविद्यालय',
        period: '2018 — 2020',
        detail: 'कनाडा',
      },
      bachelors: {
        degree: 'स्नातक डिग्री, सूचना प्रौद्योगिकी',
        school: 'चंडीगढ़ इंजीनियरिंग कॉलेज, लंदरां',
        period: '2011 — 2015',
      },
    },
    certs: {
      pbi: {
        name: 'पावर BI आवश्यक प्रशिक्षण',
        issuer: 'लिंक्डइन लर्निंग',
        issued: 'अक्टूबर 2022',
      },
      ssis: {
        name: 'SQL सर्वर इंटीग्रेशन सर्विसेज',
        issuer: 'लिंक्डइन लर्निंग',
        issued: 'अक्टूबर 2022',
      },
    },
  },
  contact: {
    title: 'संपर्क',
    subtitle:
      'डेटा, विश्लेषण या सहयोग के अवसरों पर बातचीत का मैं स्वागत करती हूँ।',
    emailLabel: 'ईमेल',
    linkedinLabel: 'लिंक्डइन',
    locationLabel: 'स्थान',
    formNote: 'ईमेल या लिंक्डइन के माध्यम से संपर्क करें — जब संभव हो तो मैं जवाब देती हूँ।',
  },
  footer: {
    rights: '© विभा शर्मा।',
    builtWith: 'React और Vite के साथ निर्मित',
  },
  controls: {
    theme: 'थीम',
    themeLight: 'लाइट',
    themeDark: 'डार्क',
    themeEnhanced: 'उन्नत डार्क',
    language: 'भाषा',
  },
}
